import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    wrapper: {
        backgroundColor: '#cad7e0',
        padding: '10px',
        fontWeight: 500,
        fontSize: '1rem',
        color: '#000',
        textAlign: 'center',
        [theme.breakpoints.down(600)]: {
            padding: '10px 0'
        }
    },
    header: {
        fontWeight: 600
    },
    message: {
        cursor: 'pointer',
        '& > span': {
            color: '#53759B'
        }
    },
    // used when props.variant === 'box'
    box: {
        margin: '30px auto'
    },
    // used when props.variant === 'top'
    top: {
        textAlign: 'center',
        fontWeight: 600,
        padding: '1.2rem'
    }
}));
